/* eslint-disable */
import React from 'react';

export type MisconceptionCardIconRender = (active: boolean) => React.ReactNode;

export const ICC_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.5678 54.5673C49.3684 58.5306 43.0372 60.7263 36.5003 60.8332C15.2087 60.8332 3.04199 36.4998 3.04199 36.4998C6.82549 29.4489 12.0731 23.2887 18.4328 18.4323M30.1128 12.8965C32.2065 12.4064 34.3501 12.1615 36.5003 12.1665C57.792 12.1665 69.9587 36.4998 69.9587 36.4998C68.1123 39.954 65.9104 43.2059 63.3887 46.2027M42.9487 42.9482C42.1133 43.8447 41.1059 44.5638 39.9865 45.0625C38.8672 45.5612 37.6589 45.8294 36.4337 45.851C35.2085 45.8726 33.9914 45.6473 32.8552 45.1883C31.719 44.7294 30.6869 44.0463 29.8204 43.1798C28.9539 42.3133 28.2708 41.2812 27.8118 40.1449C27.3529 39.0087 27.1275 37.7917 27.1491 36.5665C27.1707 35.3413 27.4389 34.1329 27.9377 33.0136C28.4364 31.8943 29.1555 30.8869 30.052 30.0515M3.04199 3.0415L69.9587 69.9582"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.8337 24.3335L42.5837 6.0835H18.2503C16.6369 6.0835 15.0896 6.72442 13.9488 7.86526C12.8079 9.00611 12.167 10.5534 12.167 12.1668V60.8335C12.167 62.4469 12.8079 63.9942 13.9488 65.1351C15.0896 66.2759 16.6369 66.9168 18.2503 66.9168H54.7503C56.3637 66.9168 57.911 66.2759 59.0519 65.1351C60.1927 63.9942 60.8337 62.4469 60.8337 60.8335V24.3335ZM42.5837 6.0835V24.3335H60.8337M27.3753 45.6252H45.6253"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.6663 48.6668C48.6663 48.6668 44.1038 42.5835 36.4997 42.5835C28.8955 42.5835 24.333 48.6668 24.333 48.6668M27.3747 27.3752H27.4051M45.6247 27.3752H45.6551M66.9163 36.5002C66.9163 53.2988 53.2983 66.9168 36.4997 66.9168C19.701 66.9168 6.08301 53.2988 6.08301 36.5002C6.08301 19.7015 19.701 6.0835 36.4997 6.0835C53.2983 6.0835 66.9163 19.7015 66.9163 36.5002Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 立方体
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63 63L49.95 49.95M57 33C57 46.2548 46.2548 57 33 57C19.7452 57 9 46.2548 9 33C9 19.7452 19.7452 9 33 9C46.2548 9 57 19.7452 57 33Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const MC_ICON: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 33L66 6L39 63L33 39L9 33Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.07 42C59.6732 40.0566 59.9866 38.0348 60 36V15L36 6L26.52 9.54M14.19 14.19L12 15V36C12 54 36 66 36 66C42.3511 62.6488 48.0591 58.2002 52.86 52.86M3 3L69 69"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.5 30C41.01 30 39 27.99 39 25.5V10.5C39 8.01 41.01 6 43.5 6C45.99 6 48 8.01 48 10.5V25.5C48 27.99 45.99 30 43.5 30Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.5 30H57V25.5C57 23.01 59.01 21 61.5 21C63.99 21 66 23.01 66 25.5C66 27.99 63.99 30 61.5 30Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5 42C30.99 42 33 44.01 33 46.5V61.5C33 63.99 30.99 66 28.5 66C26.01 66 24 63.99 24 61.5V46.5C24 44.01 26.01 42 28.5 42Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 42H15V46.5C15 48.99 12.99 51 10.5 51C8.01 51 6 48.99 6 46.5C6 44.01 8.01 42 10.5 42Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 43.5C42 41.01 44.01 39 46.5 39H61.5C63.99 39 66 41.01 66 43.5C66 45.99 63.99 48 61.5 48H46.5C44.01 48 42 45.99 42 43.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.5 57H42V61.5C42 63.99 44.01 66 46.5 66C48.99 66 51 63.99 51 61.5C51 59.01 48.99 57 46.5 57Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 28.5C30 26.01 27.99 24 25.5 24H10.5C8.01 24 6 26.01 6 28.5C6 30.99 8.01 33 10.5 33H25.5C27.99 33 30 30.99 30 28.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 15H30V10.5C30 8.01 27.99 6 25.5 6C23.01 6 21 8.01 21 10.5C21 12.99 23.01 15 25.5 15Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 立方体
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 44.28V10.5C42 8.51088 41.2098 6.60322 39.8033 5.1967C38.3968 3.79018 36.4891 3 34.5 3C32.5109 3 30.6032 3.79018 29.1967 5.1967C27.7902 6.60322 27 8.51088 27 10.5V44.28C24.5918 45.889 22.765 48.2299 21.7892 50.9568C20.8135 53.6837 20.7406 56.6522 21.5813 59.4237C22.422 62.1952 24.1317 64.6229 26.458 66.3482C28.7843 68.0735 31.6038 69.005 34.5 69.005C37.3962 69.005 40.2157 68.0735 42.542 66.3482C44.8683 64.6229 46.578 62.1952 47.4187 59.4237C48.2594 56.6522 48.1865 53.6837 47.2108 50.9568C46.235 48.2299 44.4082 45.889 42 44.28Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const CTIS_HCG_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 8H36C37.0609 8 38.0783 8.42143 38.8284 9.17157C39.5786 9.92172 40 10.9391 40 12V40C40 41.0609 39.5786 42.0783 38.8284 42.8284C38.0783 43.5786 37.0609 44 36 44H12C10.9391 44 9.92172 43.5786 9.17157 42.8284C8.42143 42.0783 8 41.0609 8 40V12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8H16M18 4H30C31.1046 4 32 4.89543 32 6V10C32 11.1046 31.1046 12 30 12H18C16.8954 12 16 11.1046 16 10V6C16 4.89543 16.8954 4 18 4Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.18 18C18.6502 16.6633 19.5783 15.5362 20.7999 14.8183C22.0215 14.1003 23.4578 13.8379 24.8544 14.0774C26.2509 14.317 27.5176 15.043 28.4302 16.1271C29.3427 17.2111 29.8421 18.583 29.84 20C29.84 24 23.84 26 23.84 26M24 34H24.02M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 36C30 39.3137 32.6863 42 36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36ZM30 36C25.2261 36 20.6477 34.1036 17.2721 30.7279C13.8964 27.3523 12 22.7739 12 18M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 18V42"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 立方体
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 7.99996H8C6.93913 7.99996 5.92172 8.42139 5.17157 9.17154C4.42143 9.92168 4 10.9391 4 12V40C4 41.0608 4.42143 42.0782 5.17157 42.8284C5.92172 43.5785 6.93913 44 8 44H36C37.0609 44 38.0783 43.5785 38.8284 42.8284C39.5786 42.0782 40 41.0608 40 40V26M37 4.99996C37.7956 4.20432 38.8748 3.75732 40 3.75732C41.1252 3.75732 42.2044 4.20432 43 4.99996C43.7956 5.79561 44.2426 6.87475 44.2426 7.99996C44.2426 9.12518 43.7956 10.2043 43 11L24 30L16 32L18 24L37 4.99996Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const MC_Section2_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21H21.03M61.77 40.23L40.26 61.74C39.7028 62.2979 39.041 62.7404 38.3126 63.0424C37.5843 63.3443 36.8035 63.4997 36.015 63.4997C35.2265 63.4997 34.4457 63.3443 33.7174 63.0424C32.989 62.7404 32.3272 62.2979 31.77 61.74L6 36V6H36L61.77 31.77C62.8875 32.8942 63.5148 34.4149 63.5148 36C63.5148 37.5851 62.8875 39.1058 61.77 40.23Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 15H24C12.402 15 3 24.402 3 36C3 47.598 12.402 57 24 57H48C59.598 57 69 47.598 69 36C69 24.402 59.598 15 48 15Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 45C52.9706 45 57 40.9706 57 36C57 31.0294 52.9706 27 48 27C43.0294 27 39 31.0294 39 36C39 40.9706 43.0294 45 48 45Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 45C40.9706 45 45 40.9706 45 36C45 31.0294 40.9706 27 36 27C31.0294 27 27 31.0294 27 36C27 40.9706 31.0294 45 36 45Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.2 45C57.8007 45.9048 57.6815 46.9086 57.858 47.8818C58.0344 48.855 58.4984 49.753 59.19 50.46L59.37 50.64C59.9279 51.1972 60.3704 51.859 60.6724 52.5874C60.9743 53.3157 61.1297 54.0965 61.1297 54.885C61.1297 55.6735 60.9743 56.4543 60.6724 57.1826C60.3704 57.911 59.9279 58.5728 59.37 59.13C58.8128 59.6879 58.151 60.1304 57.4226 60.4324C56.6943 60.7343 55.9135 60.8897 55.125 60.8897C54.3365 60.8897 53.5557 60.7343 52.8274 60.4324C52.099 60.1304 51.4372 59.6879 50.88 59.13L50.7 58.95C49.993 58.2584 49.095 57.7944 48.1218 57.618C47.1486 57.4415 46.1448 57.5607 45.24 57.96C44.3527 58.3403 43.5959 58.9717 43.0629 59.7766C42.5299 60.5815 42.2438 61.5246 42.24 62.49V63C42.24 64.5913 41.6079 66.1174 40.4826 67.2426C39.3574 68.3679 37.8313 69 36.24 69C34.6487 69 33.1226 68.3679 31.9974 67.2426C30.8721 66.1174 30.24 64.5913 30.24 63V62.73C30.2168 61.737 29.8954 60.774 29.3175 59.9661C28.7397 59.1582 27.9322 58.5429 27 58.2C26.0952 57.8007 25.0914 57.6815 24.1182 57.858C23.145 58.0344 22.247 58.4984 21.54 59.19L21.36 59.37C20.8028 59.9279 20.141 60.3704 19.4126 60.6724C18.6843 60.9743 17.9035 61.1297 17.115 61.1297C16.3265 61.1297 15.5457 60.9743 14.8174 60.6724C14.089 60.3704 13.4272 59.9279 12.87 59.37C12.3121 58.8128 11.8696 58.151 11.5676 57.4226C11.2657 56.6943 11.1103 55.9135 11.1103 55.125C11.1103 54.3365 11.2657 53.5557 11.5676 52.8274C11.8696 52.099 12.3121 51.4372 12.87 50.88L13.05 50.7C13.7416 49.993 14.2056 49.095 14.382 48.1218C14.5585 47.1486 14.4393 46.1448 14.04 45.24C13.6597 44.3527 13.0283 43.5959 12.2234 43.0629C11.4185 42.5299 10.4754 42.2438 9.51 42.24H9C7.4087 42.24 5.88258 41.6079 4.75736 40.4826C3.63214 39.3574 3 37.8313 3 36.24C3 34.6487 3.63214 33.1226 4.75736 31.9974C5.88258 30.8721 7.4087 30.24 9 30.24H9.27C10.263 30.2168 11.226 29.8954 12.0339 29.3175C12.8418 28.7397 13.4571 27.9322 13.8 27C14.1993 26.0952 14.3185 25.0914 14.142 24.1182C13.9656 23.145 13.5016 22.247 12.81 21.54L12.63 21.36C12.0721 20.8028 11.6296 20.141 11.3276 19.4126C11.0257 18.6843 10.8703 17.9035 10.8703 17.115C10.8703 16.3265 11.0257 15.5457 11.3276 14.8174C11.6296 14.089 12.0721 13.4272 12.63 12.87C13.1872 12.3121 13.849 11.8696 14.5774 11.5676C15.3057 11.2657 16.0865 11.1103 16.875 11.1103C17.6635 11.1103 18.4443 11.2657 19.1726 11.5676C19.901 11.8696 20.5628 12.3121 21.12 12.87L21.3 13.05C22.007 13.7416 22.905 14.2056 23.8782 14.382C24.8514 14.5585 25.8552 14.4393 26.76 14.04H27C27.8873 13.6597 28.6441 13.0283 29.1771 12.2234C29.7101 11.4185 29.9961 10.4754 30 9.51V9C30 7.4087 30.6321 5.88258 31.7574 4.75736C32.8826 3.63214 34.4087 3 36 3C37.5913 3 39.1174 3.63214 40.2426 4.75736C41.3679 5.88258 42 7.4087 42 9V9.27C42.0039 10.2354 42.2899 11.1785 42.8229 11.9834C43.3559 12.7883 44.1127 13.4197 45 13.8C45.9048 14.1993 46.9086 14.3185 47.8818 14.142C48.855 13.9656 49.753 13.5016 50.46 12.81L50.64 12.63C51.1972 12.0721 51.859 11.6296 52.5874 11.3276C53.3157 11.0257 54.0965 10.8703 54.885 10.8703C55.6735 10.8703 56.4543 11.0257 57.1826 11.3276C57.911 11.6296 58.5728 12.0721 59.13 12.63C59.6879 13.1872 60.1304 13.849 60.4324 14.5774C60.7343 15.3057 60.8897 16.0865 60.8897 16.875C60.8897 17.6635 60.7343 18.4443 60.4324 19.1726C60.1304 19.901 59.6879 20.5628 59.13 21.12L58.95 21.3C58.2584 22.007 57.7944 22.905 57.618 23.8782C57.4415 24.8514 57.5607 25.8552 57.96 26.76V27C58.3403 27.8873 58.9717 28.6441 59.7766 29.1771C60.5815 29.7101 61.5246 29.9961 62.49 30H63C64.5913 30 66.1174 30.6321 67.2426 31.7574C68.3679 32.8826 69 34.4087 69 36C69 37.5913 68.3679 39.1174 67.2426 40.2426C66.1174 41.3679 64.5913 42 63 42H62.73C61.7646 42.0039 60.8215 42.2899 60.0166 42.8229C59.2117 43.3559 58.5803 44.1127 58.2 45Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57 15V57M15 12L45 36L15 60V12Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const MC_Section3_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.0003 27V39M36.0003 51H36.0303M30.8703 11.58L5.46031 54C4.93641 54.9073 4.65921 55.9359 4.65627 56.9836C4.65334 58.0312 4.92478 59.0614 5.44359 59.9716C5.96239 60.8818 6.71048 61.6402 7.61343 62.1716C8.51638 62.7029 9.5427 62.9885 10.5903 63H61.4103C62.4579 62.9885 63.4842 62.7029 64.3872 62.1716C65.2901 61.6402 66.0382 60.8818 66.557 59.9716C67.0758 59.0614 67.3473 58.0312 67.3443 56.9836C67.3414 55.9359 67.0642 54.9073 66.5403 54L41.1303 11.58C40.5955 10.6983 39.8425 9.96936 38.9439 9.46346C38.0453 8.95755 37.0315 8.69177 36.0003 8.69177C34.9691 8.69177 33.9553 8.95755 33.0567 9.46346C32.1581 9.96936 31.4051 10.6983 30.8703 11.58Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51 30H9M63 18H9M63 42H9M51 54H9"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3L69 69M63 63H9C7.4087 63 5.88258 62.3679 4.75736 61.2426C3.63214 60.1174 3 58.5913 3 57V24C3 22.4087 3.63214 20.8826 4.75736 19.7574C5.88258 18.6321 7.4087 18 9 18H18M27 9H45L51 18H63C64.5913 18 66.1174 18.6321 67.2426 19.7574C68.3679 20.8826 69 22.4087 69 24V52.02M45.84 45.84C44.8443 47.2951 43.5402 48.513 42.0204 49.4069C40.5006 50.3008 38.8025 50.8488 37.0468 51.012C35.2912 51.1751 33.5212 50.9494 31.8627 50.3508C30.2042 49.7522 28.698 48.7955 27.4513 47.5487C26.2045 46.302 25.2478 44.7958 24.6492 43.1373C24.0506 41.4788 23.8249 39.7088 23.988 37.9532C24.1512 36.1975 24.6992 34.4994 25.5931 32.9796C26.487 31.4598 27.7049 30.1557 29.16 29.16"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 24C29.3726 24 24 29.3726 24 36C24 42.6274 29.3726 48 36 48C42.6274 48 48 42.6274 48 36C48 29.3726 42.6274 24 36 24ZM36 24H63.51M11.85 18.18L25.62 42M32.64 65.82L46.38 42M66 36C66 52.5685 52.5685 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6C52.5685 6 66 19.4315 66 36Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

// ExpandableListIllustration 插畫：剪貼板與清單
export const ELI_Section3_ICONS: MisconceptionCardIconRender[] = [
  () => (
    <svg
      width="280"
      height="200"
      viewBox="0 0 280 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="50"
        y="20"
        width="180"
        height="160"
        rx="14"
        stroke="currentColor"
        strokeWidth="3"
      />
      <rect
        x="110"
        y="10"
        width="60"
        height="22"
        rx="8"
        stroke="currentColor"
        strokeWidth="3"
      />
      <line
        x1="85"
        y1="65"
        x2="200"
        y2="65"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="85"
        y1="100"
        x2="200"
        y2="100"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="85"
        y1="135"
        x2="170"
        y2="135"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="72" cy="65" r="4" fill="currentColor" />
      <circle cx="72" cy="100" r="4" fill="currentColor" />
      <circle cx="72" cy="135" r="4" fill="currentColor" />
    </svg>
  ),
];

// NumberedStepsCarousel 插畫：階梯與步驟
export const NSC_Section3_ICONS: MisconceptionCardIconRender[] = [
  () => (
    <svg
      width="280"
      height="200"
      viewBox="0 0 280 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 175H75V135H120V95H165V55H225"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="52" cy="175" r="8" stroke="currentColor" strokeWidth="3" />
      <circle cx="97" cy="135" r="8" stroke="currentColor" strokeWidth="3" />
      <circle cx="142" cy="95" r="8" stroke="currentColor" strokeWidth="3" />
      <circle cx="195" cy="55" r="8" stroke="currentColor" strokeWidth="3" />
      <text
        x="52"
        y="180"
        textAnchor="middle"
        fontSize="10"
        fontWeight="700"
        fill="currentColor"
      >
        1
      </text>
      <text
        x="97"
        y="140"
        textAnchor="middle"
        fontSize="10"
        fontWeight="700"
        fill="currentColor"
      >
        2
      </text>
      <text
        x="142"
        y="100"
        textAnchor="middle"
        fontSize="10"
        fontWeight="700"
        fill="currentColor"
      >
        3
      </text>
      <text
        x="195"
        y="60"
        textAnchor="middle"
        fontSize="10"
        fontWeight="700"
        fill="currentColor"
      >
        4
      </text>
    </svg>
  ),
];
